import { useContext } from 'react';
import AppContext from 'Utils/AppContext';

/**
 * Role checks shared by every screen. READONLY accounts review only: the platform API refuses
 * any non-GET request from them (403 USER_READ_ONLY), so the UI disables the controls that
 * would send one rather than letting the click fail.
 */
export const READ_ONLY_ROLE = 'READONLY';

export const READ_ONLY_TITLE = 'Read-only account: you can review, but not change anything or start jobs';

export const isReadOnlyRole = (role) => String(role || '').toUpperCase() === READ_ONLY_ROLE;

/** True when the signed-in user may change things / start jobs (i.e. is not READONLY). */
export const useCanEdit = () => !useContext(AppContext).isReadOnly;

/** Every assignable user role, in the order the Admin panel offers them. */
export const ROLE_OPTIONS = [
  { value: 'USER', label: 'User', description: 'Can manage data sources and start jobs.' },
  { value: 'ADMIN', label: 'Admin', description: 'Everything a user can do, plus users, integrations and platform settings.' },
  { value: READ_ONLY_ROLE, label: 'Read only', description: 'Can review everything a user can see, but cannot change anything or start jobs.' },
];

export const roleLabel = (role) =>
  (ROLE_OPTIONS.find((o) => o.value === String(role || '').toUpperCase()) || {}).label || role;
